import React, { useState } from "react";
import { Button } from "primereact/button";
import { Dropdown } from "primereact/dropdown";
import { InputText } from "primereact/inputtext";
import { InputSwitch } from "primereact/inputswitch";
import { logEvent } from "../../../../utils/analytics";
import { useResponsiveLayout } from "../../../../utils/hooks/useResponsiveLayout";
import "./style.css";

export const ChatHeader = ({
  isOwner,
  shopperName,
  setShopperName,
  shopDetails,
  isClosed,
  confirmTagChange,
  onNameChange,
  selectedTag,
  isBionicReading,
  onBionicReadingToggle,
  messages,
  showChatJourney,
  onBack,
}) => {
  const [isEditingName, setIsEditingName] = useState(false);
  const [tempName, setTempName] = useState(shopperName || "");
  const { isMobile } = useResponsiveLayout();
  const MAX_NAME_LENGTH = 15;

  const tagOptions = [
    { label: "Buyer", value: "Sold" },
    { label: "Interested", value: "Interested" },
    { label: "Spam", value: "Spam" },
    { label: "Block", value: "Block" },
  ];

  const handleTagChange = (e) => {
    const newTag = e.value;
    if (newTag === selectedTag) return;

    logEvent("tagChange", { from: selectedTag, to: newTag });
    confirmTagChange(newTag);
  };

  const handleNameChange = (e) => {
    const newName =
      typeof e === "string" ? e : e.target.value.slice(0, MAX_NAME_LENGTH);
    setTempName(newName);
  };

  const handleKeyPress = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      if (tempName.trim() && tempName !== shopperName) {
        onNameChange(tempName);
        setIsEditingName(false);
      }
    }
  };

  return (
    <div className="chat-header">
      <div className={`chat-header-content ${isOwner ? "private" : ""}`}>
        {isOwner ? (
          <div className="chat-header-left">
            <div
              className="shop-info"
              style={{ display: "flex", alignItems: "center", gap: "1rem" }}
            >
              {isMobile && onBack && (
                <Button
                  icon="pi pi-arrow-left"
                  className="p-button-text p-button-sm"
                  onClick={onBack}
                  tooltip="Back to chats"
                  tooltipOptions={{ position: "bottom" }}
                />
              )}
              <h2>{shopperName || "Guest"}</h2>
            </div>
          </div>
        ) : (
          <div className="chat-header-left">
            <h2>{shopDetails?.shopName || "Shop"}</h2>
          </div>
        )}

        {!showChatJourney && selectedTag !== "Block" && (
          <div className="chat-header-right">
            <div className="bionic-reading-switch">
              <label htmlFor="bionicReading" className="bionic-reading-label">
                Bionic Reading
              </label>
              <InputSwitch
                id="bionicReading"
                checked={isBionicReading}
                onChange={(e) => onBionicReadingToggle(e.value)}
                tooltip={
                  isBionicReading
                    ? "Disable Bionic Reading"
                    : "Enable Bionic Reading"
                }
                tooltipOptions={{ position: "bottom" }}
              />
            </div>
            {isOwner &&
              selectedTag &&
              !selectedTag.includes("Changed name") && (
                <Dropdown
                  value={selectedTag}
                  options={tagOptions}
                  onChange={handleTagChange}
                  placeholder="Tag Chat"
                  className="chat-tag-dropdown"
                  disabled={isClosed}
                />
              )}
          </div>
        )}
      </div>
    </div>
  );
};
